import { MoonNumericField } from "./MoonNumericField";

/**
 * Currency-formatted numeric input. Thin wrapper around MoonNumericField
 * that pins decimals to 2 and adds a currency prefix (default "$").
 *
 * Replaces the hand-rolled "$ prefix + TextInput with decimal-pad keyboard"
 * pattern in the cost / coverage screens (audit task 2.2 → "Number/currency
 * entries hand-rolled in 6+ modals").
 *
 * Value is the parsed number (or null when empty). The prefix is purely
 * presentational — never present in `value`.
 */
type Props = {
  label: string;
  value: number | null;
  onChange: (next: number | null) => void;
  placeholder?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  disabled?: boolean;
  loading?: boolean;
  min?: number;
  max?: number;
  /** Currency symbol prefix. Defaults to "$". */
  currency?: string;
  testID?: string;
};

export function MoonCurrencyInput({ currency = "$", ...rest }: Props) {
  return <MoonNumericField {...rest} decimals={2} prefix={currency} />;
}
